import script from "./CreateWalletModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateWalletModal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__